import WorkUserReports from './element/WorkflowUserReport'

const Reports = () => {
  return (
    <WorkUserReports />
)
}

export default Reports;